import Controller from '@ember/controller';
import { service } from '@ember/service';
import type Store from '@ember-data/store';
import { tracked } from '@glimmer/tracking';
const PAGE_SIZE = 50;

export default class OrganizationDonorsIndexController extends Controller {
  @service declare store: Store;

  queryParams = ['q', 'page'];

  @tracked q = '';
  @tracked page = 1;
  @tracked loading = false;
  @tracked totalPages = 1;
  @tracked entities: any[] = [];

  handleLifecycle = () => {
    setTimeout(() => {
      if (this.q.length >= 2) {
        this.load();
      }
    });
    return () => {
      this.q = '';
      this.page = 1;
      this.loading = false;
      this.totalPages = 1;
      this.entities = [];
    }
  }

  handleSearchChange = (e: any) => {
    this.q = e.target.value.trim();
  }

  handleSearchEnter = (e: any) => {
    this.handleSearchChange(e);
    this.page = 1;
    this.load();
  }

  handleSearchClicked = () => {
    this.page = 1;
    this.load();
  }

  handleChangePage = (pageNumber: number) => {
    this.page = pageNumber;
    this.load();
  }

  load = async () => {
    this.loading = true;
    this.entities = [];
    this.totalPages = 1;

    const { q } = this;
    const offset = (this.page - 1) * PAGE_SIZE;
    if (q.length === 0) {
      this.entities = [];
      this.totalPages = 1;
      this.loading = false;
      return;
    } else if (q.length < 2) {
      this.loading = false;
      alert('You must enter at least 2 characters in the search');
      return;
    }

    let response = await this.store.query('organization/entity', {
      filter: { q, offset, limit: PAGE_SIZE }
    });

    const totalCount = (response as any).meta.total_count || 0;
    this.totalPages = Math.ceil(totalCount / PAGE_SIZE);
    this.entities = response.slice();

    this.loading = false;
  }


  //   actions: {
  //     applyFilter() {
  //       let qInput = (this.qInput || '').trim();
  //       if (qInput.length < 2) {
  //         alert('You must enter at least 2 characters in the search');
  //         return;
  //       }
  //       setProperties(this, {
  //         q: qInput,
  //         page: 1,
  //       });
  //     },
  //     changePage(pageNumber) {
  //       set(this, 'page', pageNumber);
  //     },
  //   },
  // });
}
